import { h } from 'preact';
export const VolumeX = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("polygon", { points: "11 5 6 9 2 9 2 15 6 15 11 19 11 5" }),
        h("line", { x1: "23", y1: "9", x2: "17", y2: "15" }),
        h("line", { x1: "17", y1: "9", x2: "23", y2: "15" })));
};
//# sourceMappingURL=volume-x.js.map